// extracted by css-extract-rspack-plugin
export default {"root":"QeDAGO","heading":"qrq56Z","description":"BBDy_g"};